import { render, staticRenderFns } from "./TranslatableTextField.vue?vue&type=template&id=809fd820"
import script from "./TranslatableTextField.vue?vue&type=script&lang=js"
export * from "./TranslatableTextField.vue?vue&type=script&lang=js"
import style0 from "./TranslatableTextField.vue?vue&type=style&index=0&id=809fd820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports